import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import SurveyTemplateTable from 'components/surveyTemplate/SurveyTemplateTable';
import DeleteModal from 'components/surveyTemplate/DeleteModal';
import SurveyTemplateApi from 'apis/SurveyTemplate';
import Loading from 'utils/Loading';
import { ROUTES } from 'constants/Routes.js';

class SurveyTemplateListContainer extends Component {
  constructor() {
    super();
    this.state = {
      surveyTemplates: [],
      deleteId: null,
      deleteName: null,
      modalToggle: false,
      businessCount: null,
      questionCount: null,
      loaded: false,
      searchText: '',
    };
    this.deleteSurveyTemplate = this.deleteSurveyTemplate.bind(this);
  }

  componentWillMount() {
    this.fetchSurveyTemplates();
  }

  fetchSurveyTemplates = () => {
    SurveyTemplateApi.getAll()
      .then(({ data }) => {
        this.setState({ surveyTemplates: data, loaded: true });
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Error while fetching data
            </div>
          )),
          () => {
            console.log(e);
          }
        )
      );
  };

  deleteSurveyTemplate = (id, name, businessCount, questionCount) => {
    this.setState({
      modalToggle: true,
      deleteId: id,
      deleteName: name,
      businessCount: businessCount,
      questionCount: questionCount,
    });
  };

  cancelDelete = () => {
    this.setState({
      modalToggle: false,
    });
  };

  confirmDeleteSurveyTemplate = () => {
    const { deleteId, deleteName } = this.state;
    SurveyTemplateApi.delete(deleteId)
      .then(({ data }) => {
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />
            Deleted {deleteName} from survey template list
          </div>
        ));
        this.cancelDelete();
        this.fetchSurveyTemplates();
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" /> Error while
              deleting survey template {deleteName}
            </div>
          )),
          console.log(e)
        )
      );
  };

  handleFilterInput = e => {
    const { value } = e.target;

    this.setState({ searchText: value });
  };

  render() {
    const {
      loaded,
      modalToggle,
      deleteName,
      businessCount,
      questionCount,
      deleteId,
      surveyTemplates,
      searchText,
    } = this.state;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <div className="container">
        <DeleteModal
          modalToggle={modalToggle}
          deleteName={deleteName}
          businessCount={businessCount}
          deleteId={deleteId}
          questionCount={questionCount}
          cancelDelete={this.cancelDelete}
          confirmDeleteCategory={this.confirmDeleteSurveyTemplate}
        />
        <div className="row mb-4 justify-content-end">
          <div className="pl-lg-5 col-lg-9 col-md-12 input-group justify-content-end">
            <input
              className="col-lg-9 col-md-12 form-control search-text-box"
              placeholder="Enter search keyword"
              value={searchText}
              onChange={this.handleFilterInput}
            />
            <div className="input-group-append">
              <button className="btn btn-add-new d-flex align-items-center justify-content-center">
                <FontAwesomeIcon icon="search" className="d-none d-md-block" />
                Search
              </button>
            </div>
            <NavLink
              to={ROUTES.ADD_NEW_SURVEY_TEMPLATE}
              className="ml-1 col-lg-3 col-md-12 btn btn-light btn-add-new d-flex justify-content-center align-items-center mt-3 mt-lg-0"
            >
              <FontAwesomeIcon icon="plus" />
              Add Template
            </NavLink>
          </div>
        </div>
        <div>
          <SurveyTemplateTable
            surveyTemplates={surveyTemplates}
            deleteSurveyTemplate={this.deleteSurveyTemplate}
            searchText={searchText}
          />
        </div>
      </div>
    );
  }
}

SurveyTemplateListContainer.propTypes = {
  history: PropTypes.object,
};

export default SurveyTemplateListContainer;



// WEBPACK FOOTER //
// ./src/containers/SurveyTemplateList.js